// Image and Asset Paths
export const LOGO = "/phuong-logo-trans.png";
export const CHARACTERS_MAIN = "/new-hero-image.png";
export const FEATURES_BG = "/phuongbg.png";
export const CHARACTER_1 = "/phuong-adult.png";
export const CHARACTER_2 = "/1OCIDNV1774147976995.png";
export const CHARACTER_3 = "/KSNU3SW1774178090017.png";
export const BLUEBERRY_BG = "/tired-horse.png";

// Policy background images
export const POLICY_BG_PRIVACY = "/shield.png";
export const POLICY_BG_TERMS = "/service.png";
export const POLICY_BG_COMMUNITY = "/phuonggroup.png";
